var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { LoadingOutlined, ScanOutlined } from '@ant-design/icons';
import { Button, message, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
var ReceivingScanInput = function (_a) {
    var placeholder = _a.placeholder, showQtyInput = _a.showQtyInput, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, buttonLabel = _a.buttonLabel, errorText = _a.errorText, _d = _a.productNotAssociatedWithShipment, productNotAssociatedWithShipment = _d === void 0 ? false : _d, _e = _a.unknownProductPending, unknownProductPending = _e === void 0 ? false : _e, _f = _a.unknownProductPartyUrl, unknownProductPartyUrl = _f === void 0 ? '' : _f, _g = _a.focusSignal, focusSignal = _g === void 0 ? 0 : _g, onSubmit = _a.onSubmit, onProceedUnassociated = _a.onProceedUnassociated, onCancelUnassociated = _a.onCancelUnassociated, onProceedUnknown = _a.onProceedUnknown, onCancelUnknown = _a.onCancelUnknown;
    var t = useTranslation().t;
    var scanInputRef = useRef(null);
    var quantityInputRef = useRef(null);
    var submitLockRef = useRef(false);
    var lastSubmittedScanIdRef = useRef('');
    var onProceedUnassociatedRef = useRef(onProceedUnassociated);
    var onCancelUnassociatedRef = useRef(onCancelUnassociated);
    var onProceedUnknownRef = useRef(onProceedUnknown);
    var onCancelUnknownRef = useRef(onCancelUnknown);
    onProceedUnassociatedRef.current = onProceedUnassociated;
    onCancelUnassociatedRef.current = onCancelUnassociated;
    onProceedUnknownRef.current = onProceedUnknown;
    onCancelUnknownRef.current = onCancelUnknown;
    var _h = useState(''), scanInput = _h[0], setScanInput = _h[1];
    var _j = useState('1'), quantityInput = _j[0], setQuantityInput = _j[1];
    var _k = useState(false), isSubmitting = _k[0], setIsSubmitting = _k[1];
    var isBusy = loading || isSubmitting;
    var focusScanInput = useCallback(function () {
        var _a;
        var input = scanInputRef.current;
        if (!input)
            return;
        input.focus();
        (_a = input.select) === null || _a === void 0 ? void 0 : _a.call(input);
    }, []);
    useEffect(function () {
        if (disabled || isBusy)
            return;
        var timerId = window.setTimeout(focusScanInput, 0);
        return function () { return window.clearTimeout(timerId); };
    }, [disabled, isBusy, focusSignal, focusScanInput]);
    useEffect(function () {
        if (!productNotAssociatedWithShipment || !errorText)
            return;
        var modal = Modal.confirm({
            title: '',
            icon: '',
            content: errorText,
            okText: t('Proceed'),
            cancelText: t('Cancel'),
            onOk: function () { var _a; return (_a = onProceedUnassociatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onProceedUnassociatedRef, lastSubmittedScanIdRef.current); },
            onCancel: function () { var _a; return (_a = onCancelUnassociatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCancelUnassociatedRef); }
        });
        return function () {
            modal.destroy();
        };
    }, [productNotAssociatedWithShipment, errorText, t]);
    useEffect(function () {
        if (!unknownProductPending || !errorText)
            return;
        var modal = Modal.confirm({
            title: '',
            icon: '',
            content: (_jsxs("div", { children: [_jsx("div", __assign({ style: { whiteSpace: 'pre-line' } }, { children: errorText }), void 0), unknownProductPartyUrl && (_jsxs("div", __assign({ className: 'mt-4 flex flex-wrap gap-2' }, { children: [_jsx(Button, __assign({ onClick: function () { return window.open(unknownProductPartyUrl, '_blank'); } }, { children: t('Go to party') }), void 0), _jsx(Button, __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, navigator.clipboard.writeText(unknownProductPartyUrl)];
                                            case 1:
                                                _a.sent();
                                                message.success(t('Link copied'));
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } }, { children: t('Copy link') }), void 0)] }), void 0))] }, void 0)),
            closable: !!unknownProductPartyUrl,
            okText: t('Continue'),
            cancelText: t('Cancel'),
            okButtonProps: unknownProductPartyUrl ? { style: { display: 'none' } } : undefined,
            cancelButtonProps: unknownProductPartyUrl ? { style: { display: 'none' } } : undefined,
            onOk: function () { var _a; return (_a = onProceedUnknownRef.current) === null || _a === void 0 ? void 0 : _a.call(onProceedUnknownRef); },
            onCancel: function () { var _a; return (_a = onCancelUnknownRef.current) === null || _a === void 0 ? void 0 : _a.call(onCancelUnknownRef); }
        });
        return function () {
            modal.destroy();
            window.setTimeout(focusScanInput, 0);
        };
    }, [unknownProductPending, unknownProductPartyUrl, errorText, t, focusScanInput]);
    var handleSelectAll = useCallback(function (event) {
        var _a, _b;
        (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.select) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    var submit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmed;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (disabled || isBusy || submitLockRef.current)
                        return [2 /*return*/];
                    trimmed = scanInput.trim();
                    if (!trimmed)
                        return [2 /*return*/];
                    if (showQtyInput && !/^[1-9]\d*$/.test(quantityInput.trim())) {
                        (_a = quantityInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        (_c = (_b = quantityInputRef.current) === null || _b === void 0 ? void 0 : _b.select) === null || _c === void 0 ? void 0 : _c.call(_b);
                        return [2 /*return*/];
                    }
                    submitLockRef.current = true;
                    setIsSubmitting(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, , 3, 4]);
                    lastSubmittedScanIdRef.current = trimmed;
                    return [4 /*yield*/, onSubmit(trimmed, showQtyInput ? Number(quantityInput) : 1)];
                case 2:
                    _d.sent();
                    setScanInput('');
                    setQuantityInput('1');
                    return [3 /*break*/, 4];
                case 3:
                    submitLockRef.current = false;
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [disabled, isBusy, scanInput, quantityInput, showQtyInput, onSubmit]);
    return (_jsxs("div", { children: [_jsxs("form", __assign({ className: "flex items-center gap-2 rounded-xl border px-3 py-2 " + (disabled || isBusy
                    ? 'border-gray-200 bg-gray-100'
                    : 'border-gray-300 bg-gray-50 focus-within:border-primary'), onSubmit: function (event) {
                    event.preventDefault();
                    void submit();
                } }, { children: [_jsx(ScanOutlined, { style: { fontSize: 14, color: '#9ca3af' } }, void 0), _jsx("input", { ref: scanInputRef, type: 'text', value: scanInput, disabled: disabled || isBusy, placeholder: placeholder, onFocus: handleSelectAll, onClick: handleSelectAll, onChange: function (event) { return setScanInput(event.target.value); }, className: 'min-w-0 flex-1 border-none bg-transparent text-sm font-medium text-gray-500 outline-none placeholder:text-gray-400' }, void 0), showQtyInput && (_jsx("input", { ref: quantityInputRef, type: 'number', min: 1, step: 1, value: quantityInput, disabled: disabled || isBusy, placeholder: t('Qty'), inputMode: 'numeric', onFocus: handleSelectAll, onClick: handleSelectAll, onChange: function (event) { return setQuantityInput(event.target.value); }, className: 'w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-center text-xs font-semibold text-gray-600 outline-none focus:border-primary' }, void 0)), _jsx("button", __assign({ type: 'button', className: 'rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-bold tracking-wide text-gray-500', disabled: disabled || isBusy, onClick: function () { return void submit(); } }, { children: isBusy ? _jsx(LoadingOutlined, { spin: true, style: { fontSize: 8 } }, void 0) : "\u21B5 " + buttonLabel }), void 0), _jsx("button", { type: 'submit', className: 'hidden', "aria-hidden": 'true', tabIndex: -1 }, void 0)] }), void 0), errorText && !productNotAssociatedWithShipment && !unknownProductPending && (_jsx("p", __assign({ className: 'mt-2 rounded-md bg-red-50 px-2.5 py-1.5 text-xs font-medium text-red-600' }, { children: errorText }), void 0))] }, void 0));
};
export default ReceivingScanInput;
